<template>
    <div v-if="mainElement">
        <!-- modelo_bandeja -->
        <editParameterValueComponent ref="editParameterValueComponent"
            :parameter="mainElement['modelo_bandeja']"
            :prop_title_show="true"
            :value.sync="mainElement['modelo_bandeja'].value"
            @update:value="refreshParameters">
        </editParameterValueComponent>

        <!-- dimensiones_bandeja_porticos -->
        <editParameterValueComponent ref="editParameterValueComponent"
            :parameter="mainElement['dimensiones_bandeja_porticos']"
            :prop_title_show="true"
            :value.sync="mainElement['dimensiones_bandeja_porticos'].value"
            @update:value="refreshParameters">
        </editParameterValueComponent>

        <!-- opcion_base_porticos -->
        <editParameterValueComponent ref="editParameterValueComponent"
            :parameter="mainElement['opcion_base_porticos']"
            :prop_title_show="true"
            :value.sync="mainElement['opcion_base_porticos'].value"
            @update:value="refreshParameters">
        </editParameterValueComponent>

        <!-- opcion_tapa -->
        <editParameterValueComponent ref="editParameterValueComponent"
            :parameter="mainElement['opcion_tapa']"
            :prop_title_show="true"
            :value.sync="mainElement['opcion_tapa'].value"
            @update:value="refreshParameters">
        </editParameterValueComponent>

        <!-- opcion_compartimento -->
        <editParameterValueComponent ref="editParameterValueComponent"
            :parameter="mainElement['opcion_compartimento']"
            :prop_title_show="true"
            :value.sync="mainElement['opcion_compartimento'].value"
            @update:value="refreshParameters">
        </editParameterValueComponent>
        <p>Nivel {{ mainElement['numero_nivel'].value }}</p>
        <p>Posición {{ mainElement['posicion_bandeja'].value }}</p>
    </div>
</template>
<script>
import Vue from "vue";
import { app } from "../../../application.js";
import G60Helper from "./G60Helper.js";
import editParameterValueComponent from "./../../editParameterValue.vue";
import diagnosticsComponent from "../../common/diagnostics.vue";

export default {
    props: {
        mainElement: null
    },
    components: {
        editParameterValueComponent
    },
    data() {
        return {
            app: app,
            helper: new G60Helper(app)
        }
    },
    methods: {
        refreshParameters() {
            this.$emit("update:value");
        }
    }
}
</script>